import ATouchAwaySettings from "./ATouchAwaySettings";
export default ATouchAwaySettings;